import Axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

export const useDataFormatterHook = ({
  value,
  text,
  path,
  addEmpty = false,
  emptyValue = "",
  emptyText = "All",
  defaultValue = [],
  onGetList,
}) => {
  const [values, setValues] = useState(defaultValue);
  useEffect(() => {
    if (!path) return;
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + path;
    Axios.get(url)
      .then((response) => response.data)
      .then((data) => {
        let responseData = data.map((item) => ({
          value: item[value],
          text: item[text],
          item,
        }));

        if (addEmpty) {
          responseData.unshift({ value: emptyValue, text: emptyText });
        }

        if (onGetList) {
          responseData = onGetList(responseData);
        }

        setValues(responseData);
      });
  }, [value, text, path, addEmpty, emptyValue, emptyText, onGetList]);

  const findItem = useCallback(
    (id) => values.find((item) => item?.value === id),
    [values]
  );

  const formatter = useCallback(
    (cell, row, text) => {
      if (text) return findItem(cell)?.text;
      return <span>{findItem(cell)?.text}</span>;
    },
    [findItem]
  );

  return {
    values,
    formatter,
  };
};
